.map-legend {
  background-color: rgba(249, 251, 251, 0.8);
  padding: 5px 0;
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  & svg {
    width: 100%;
    height: 100%;
  }

  & svg text {
    font-weight: 500;
    cursor: default;
  }
}
